import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

if (environment.sentryEnv) {
  Sentry.init({
    dsn: 'https://2ea27f9e9a564080b5d3d84c7d47b297@o456764.ingest.sentry.io/5450131',
    environment: environment.sentryEnv,
    release: environment.sentryRelease,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Sentry.replayIntegration({ maskAllText: false }), // causes error in drag&drop
    ],
    tracePropagationTargets: ['localhost', /^https:\/\/(?!((stage-)?login\.))[a-z0-9-.]+\.trendemon\.com\//],
    maxValueLength: 1000,

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    ignoreErrors: ['Non-Error exception captured', "Cannot read properties of null (reading 'close')"],
    // beforeSend: event => {
    //   return event;
    // }
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
